import { render } from "./EstimationCost.vue?vue&type=template&id=2384e94c&scoped=true&ts=true"
import script from "./EstimationCost.vue?vue&type=script&lang=ts"
export * from "./EstimationCost.vue?vue&type=script&lang=ts"

import "./EstimationCost.vue?vue&type=style&index=0&id=2384e94c&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/range-compose-campaign-ui_master/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2384e94c"]])

export default __exports__